const additionalSellerDomains: Record<number, string[]> = {
  13: ["tendium.com"],
};

export function normalizeSellerDomain(value: string | null | undefined) {
  const trimmed = value?.trim().toLowerCase() ?? "";
  if (!trimmed || trimmed === "unknown") return "";
  try {
    const url = new URL(trimmed.includes("://") ? trimmed : `https://${trimmed}`);
    return url.hostname.replace(/^www\./, "");
  } catch {
    return trimmed
      .replace(/^https?:\/\//, "")
      .replace(/^www\./, "")
      .split(/[/?#]/)[0];
  }
}

export function getCompanySellerDomains(
  companyId: number,
  companyDomain: string | null | undefined,
) {
  return [...new Set([
    normalizeSellerDomain(companyDomain),
    ...(additionalSellerDomains[companyId] ?? []).map(normalizeSellerDomain),
  ].filter(Boolean))];
}
